import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAdmin } from '@/hooks/useAdmin';
import { AdminAction } from '@/types/admin';
import { Json } from '@/integrations/supabase/types';

interface LogEntry {
  action: AdminAction;
  targetType?: string;
  targetId?: string;
  details?: Record<string, unknown>;
}

export function useAuditLog() {
  const { admin } = useAdmin();

  const logAction = useCallback(async ({ action, targetType, targetId, details }: LogEntry) => {
    if (!admin) return;

    try {
      await supabase.from('admin_audit_logs').insert({
        admin_id: admin.id,
        action,
        target_type: targetType,
        target_id: targetId,
        details: details as Json,
        // ip_address is typically handled by edge function or middleware, 
        // client-side generic IP might not be accurate/available directly here easily without external service.
        // We skip IP for client-side insert for now.
      });
    } catch (error) {
      console.error('Failed to log audit entry:', error);
      // Don't throw, just log error, audit logging shouldn't break the app flow
    }
  }, [admin]);

  return { logAction };
}
